module.exports = __webpack_public_path__ + "img/societalBenefits.cebb4077.png";